import axios from "axios";
import { getOptions } from "./collection";
import { URL_BASE } from "./constant";
import { LanguageService, CountryService } from "@/services/storage.service";

export const makeRequest = (
  endpoint,
  method = null,
  token = null,
  data = {},
  urlBase,
  add = true
) => {
  if (data == null) {
    data = {};
  }

  const url = urlBase == undefined ? URL_BASE + endpoint : urlBase + endpoint;
  let language = LanguageService.getLanguage();
  let country = CountryService.getCountry();
  let position = JSON.parse(window.localStorage.getItem("Geolocation"));
  if (add) {
    if (!language) {
      language = 2;
    }
    if (!country) {
      country = 230;
    }
    if (position) {
      data["Latitude"] = position.latitude;
      data["Longitude"] = position.longitude;
    } else {
      data["Latitude"] = -1;
      data["Longitude"] = -1;
    }
    if (!data.hasOwnProperty("LanguageID")) {
      data["LanguageID"] = /* language.lang_id || */ 1;
    }
    data["CountryID"] = country.CountryID;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      data["BookingType"] = "Mobile Site";
    } else {
      data["BookingType"] = "Website";
    }
  }
  const options = getOptions(url, method, token, data);
  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => resolve({ error: false, res: res }))
      .catch(error => {
        reject({ error: error, res: null });
      });
  });
};

// export const makeRequestDirect = (endpoint, method = null, token = null, data = null) => {
//   // const url = URL_BASE + endpoint;
//   const url = 'http://api.ticketak.com' + endpoint
//   const options = getOptions(url, method, token, data)
//   return new Promise((resolve, reject) => {
//     axios(options)
//       .then(res => resolve({ error: false, res: res }))
//       .catch(error => {
//         reject({ error: true, res: null })
//       })
//   })
// }



// WEBPACK FOOTER //
// ./src/helper/internet.js